import React from "react";
import { Box, Typography } from "@mui/material";
import GvPrimaryButton from "../../../../components/GvPrimaryButton/GvPrimaryButton";
import { PREQUAL_COLORS } from "../constants";
import { PrequalCheckCircle } from "./PrequalCheckCircle";
import { PrequalStatusPill } from "./PrequalStatusPill";

interface IPrequalResultLayoutProps {
  pillLabel?: string;
  title: string;
  subtitle: string;
  children: React.ReactNode;
  ctaLabel: string;
  onCta: () => void;
  onMaybeLater: () => void;
  emailNotice?: string;
}

// Shared page shell for the eligibility-result screens and the
// already-qualified gate: pill + check circle + copy + billing card(s) +
// CTA + "Maybe Later" + optional email footer (Figma 35828-52079 /
// 35825-51251).
export const PrequalResultLayout = ({
  pillLabel,
  title,
  subtitle,
  children,
  ctaLabel,
  onCta,
  onMaybeLater,
  emailNotice,
}: IPrequalResultLayoutProps) => (
  <Box className="flex h-full w-full flex-col items-center justify-center px-4 py-8 text-center">
    {pillLabel ? <PrequalStatusPill label={pillLabel} /> : null}
    <PrequalCheckCircle />
    <h1
      className="grenette-pro mt-6 text-[28px] font-semibold leading-tight sm:text-[40px]"
      style={{ color: PREQUAL_COLORS.textDark }}
    >
      {title}
    </h1>
    <p
      className="geograph-regular mt-3 max-w-2xl text-[18px] leading-normal"
      style={{ color: PREQUAL_COLORS.textMuted }}
    >
      {subtitle}
    </p>
    <div className="mt-8 flex w-full flex-col items-center justify-center gap-4 sm:w-auto sm:flex-row">
      {children}
    </div>
    <div className="mt-6 w-full max-w-[340px]">
      <GvPrimaryButton type="button" onClick={onCta}>{ctaLabel}</GvPrimaryButton>
    </div>
    <button type="button" className="geograph-medium mt-4 text-sm font-semibold" onClick={onMaybeLater}>
      Maybe Later
    </button>
    {emailNotice ? (
      <Typography variant="caption" sx={{ mt: 3, color: "text.secondary" }}>
        {emailNotice}
      </Typography>
    ) : null}
  </Box>
);
